var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmbedCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#pattern0_2608_4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2608_4",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2608_4",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2608_4",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFCUlEQVR4nO2dW2icRRTHfzHWRrEY6qVoEFG81FQsWjUiCCK0FsQrDeqDiJi3KoIpSC+CrQ+xoOA+KIJCY0VBBYuCDyqtNxTR5kFQxFREvNAqir1510SGTmQJuzvn2+8y59s5P5iXhZ05M2e/mfOd/8wsGIZhGIZhGIZhGIZhGIZhGEadOA/oi22EcYRB4A/gG6ABrPCfG5EYA2bnlc+AB4GzYxuXIjtbOGSuzAATsQ1MidOAfzo4xJU1sY1MifGAMw4Ax8Y2MiWmAg7ZFtvAlFgacIYrK2MbmRJbAs74ATg6tpEpMR1wyGOxDUyJEcF0dVlsI1OiEXDGlymkUhYB/bGN4IgNewMO2VxQO67PKnGL45vA6z53FJNVgulqOGcbzhGvAu8Ax6CQJ5o6+wVwbkRbJgPO2J2z/rOAT5vqexpl3Nui0z8BV0WwZQDYH3DIfTnqv8KHy/PrvAclXAP83abjfwJ3VmzPaMAZ/wJDXdZ9G/B7m3pdvuxaIrPM54JC8/XWCm16OWCLy/x2w1ZBP92TeT6ROBHYIzDSlfUVC1GzHcpdXda9QdjXr4CTqZgFwFtCA1+oMN4fC9jiptDFOerfLuzzu8BCKuQpoWHvV2zYroA9bjrLgwtv3xb2vbIs8nqhQV8DS3pQiDrJv+VLxiBPNCfiJh+lhAw5CFxI7wpRw4LQetaP1XWUxEXAYaER19P7QtRqwRNZ2o/zVL+FRsVjqkiIGs8wfZ9SVKPuMf9Q20KmSIh6ssoAx4Wrz2sN9ZQIUQsC24yayzN5G3tI88uQIiFqseBHMVfuz5MTmhE04KKXC4hHQ4kQ5daxX4RBz41ZK78E+FVQeeyEWn9FQpSUlR0Src3lNz/GIs4A9gkfv7X0vhCVlbuFY/e9JOt8PPCJsEINosxkyUJUtzwuHENn33HtKjkKeEVY0RsK9jMNlCxE5Z1KXxOO5Yvt1rhHhBV8rkAzL1uIKoJBP1aSMX1g/pfvEH7xZ+AcdLCjJCGqSM4EfhSMq4tmb2nWiEOijit/AVejg8EShaiiudLrMJLI69K6OmSsZCEqqkPqOGXtKlmIijplzfFoTRb1IYEm4xb82ORa1OsU9o7X4ERUlrD3pU6pnUU1eDGcqsGJqEJeDJtTJ6125rUqLk1QJUtrcCKq0NTJHNLIq+rk4hblJ6KyJBf/j6ik3C70dJXp92nFJ6Kk6feWEZWUCUUC1YjiE1FZBKpNeRrq8zsPJQ29V7KE21B6IiqLhNs2kZgFF0J+JGxwWyJCVDebHEQRVZZdgd8JG15HGkJUlm1AmSIqKSuEsq57i74hASFqtXCjXFcRlZQ1wo0Ph4DlPSxEDQu3kuaKqKRsrniz9agyISrLZuuNVRiUZfPcxwUsZDsUCVFZjiMUElGVsb00j2GDyoSo7TEiqjI2YG/qASFqQ8yISsrFwiMKz3X5lOxUJEQ9LOjnYX9sIyo3dxCMZnxH+nrkar5bfRgbLaKSsrHNr8WduOo1IeryNlkDN6WpwT0BzzYZ920Bd+NOKRaihnwEGSWiyvIC94EvSxIQogb82hglospymcDCCl4+9yq5Bso9FSeQANMBh9jVfBUyIpiu7Gq+CmkEnJHE1Xxa6FcsRCXJKqVCVLJMKj0RlSQDCoWopBlVfiIqOSYC8rCGE1HJcbq/4XS34hNRybLM/0fUHmUnopKnz//lnWEYhmEYhmEYhmEYhmEYhmFQD/4DZ96YPB5ZuJUAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbedCopy);
export default __webpack_public_path__ + "static/media/embedCopy.c89508093e0e2b64d1cfe4c5ab431d29.svg";
export { ForwardRef as ReactComponent };